// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".definitions-tooltip__expression{cursor:pointer;border-bottom:2px dotted currentColor}.definitions-tooltip__expression:focus{outline:none;background-color:rgba(0,0,0,.05)}.tippy-tooltip.left-theme .tippy-content{text-align:left}", ""]);
// Exports
module.exports = exports;
